<template>
  <base-modal form title="New Facility Extra" body-class="is-paddingless">
    <notification class="is-secondary is-radiusless is-marginless">
      An editbale extra will be created for each customer role assigned to the facility.
    </notification>
    <div class="columns is-multiline p-2">
      <div class="column is-12">
        <text-input
          :label="false"
          v-model="extra.description"
          :error="errors.description"
          placeholder="Describe this extra"
          error-class="has-text-danger"/>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="extra.price"
          :error="errors.price"
          error-class="has-text-danger">
          <static-button slot="left">R</static-button>
          <static-button slot="right">Price inc VAT</static-button>
        </formatted-text-input>
      </div>
    </div>
    <div slot="footer" class="buttons">
      <submit-button
        :disabled="loading"
        :working="working"
        @submit="save"
        class="is-success is-rounded">
        Save
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { newExtra } from '@/api/facility'
export default {

  data:() => ({
    loading: false,
    working: false,
    extra: {
      price: '',
      description: ''
    }
  }),

  methods: {
    save() {
      this.working = true
      newExtra({
        facility: this.facilityId,
        extra: this.extra
      }, () => {
        this.$toast.success('Extra saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }

}
</script>
